<template>
	<div id="devicetypeList" class="wrapper wrapper-content fadeInRight tabBox">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<!--表单查询开始-->
			<div class="form-horizontal" id="search">
				<div class="form-group">
					<label class="col-sm-1  control-label">设备协议ID</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.protocolId" maxlength="30">
					</div>
					<label class="col-sm-1  control-label">设备协议名</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.deviceProtocol" maxlength="30">
					</div>
				</div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button class="btn btn-primary" @click="searchInfo">查询</button>
						<button class="btn btn-primary" @click="reset">重置</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button class="btn btn-primary" @click="createNew()">新增设备协议</button>
					</div>
				</div>
			</div>
			<!--表单查询结束-->
			<!--表格开始-->
			<div class="table-responsive ">
				<table class="table table-striped table-bordered fixedTable">
					<thead>
						<tr>
							<th>设备协议ID</th>
							<th>设备协议名</th>
						    <th>设备型号</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(deviceInfo,index) in devices" v-bind:key="index" class="list-complete-item">
							<td>{{deviceInfo.protocolId}}</td>
							<td>{{deviceInfo.deviceProtocol}}</td>
							<td>{{deviceInfo.categoryNo}}</td>
							<td class="text-center">
								<a class="text-right" @click="edit(deviceInfo,index)">编辑&nbsp;</a>
								<a @click="remove(deviceInfo)">&nbsp;删除</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
	    	<!--分页组件开始-->
	    	 <pagination v-if="devices.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination> 
			<!--分页组件结束-->
			
	        <sub-page :show="showSubPage" :bigTitleMsg="title" v-on:cancel="endEdit" :scroll="scrollTop">
		 		<div slot="bodycontent">
					<page-device-protocol-edit :editItem="editItem"  
						  :mode='editMode' :deviceCategoryId="deviceCategoryId"
						  :brandCode="brandCode"
						   v-on:toClose="endEdit"
						   ref="edit"
						   >
					</page-device-protocol-edit>
				</div>
			</sub-page> 
		</div>
		<!--   弹出框子组件        -->
		<tab-modal ref="modal1" size="small" title="提示" :scroll='scrollTop' v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
				<button @click="closeModalMsg" class="btn btn-primary">确定</button>
			</div>
		</tab-modal>
		<!--   弹出框子组件2        -->
			<tab-modal ref="modal2" size="small" title="提示" :scroll='scrollTop' v-on:cancel="closeModal('modal2')">
				确定删除该设备类型？
				<div slot="footer">
					<button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
					<button @click="removeC()" class="btn btn-primary">确定</button>
				</div>
			</tab-modal>
	</div>
</template>

<script>
	import SubPage from 'components/common/SubPage'
	import Pagination from 'components/common/Pagination'
	import PageDeviceProtocolEdit from 'components/pages/deviceprotocol/PageDeviceProtocolEdit'
	import TabModal from 'components/common/TabModal'
	import { DICTIONARY_MAP } from 'static/constant'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import { INFO_STATUS_ALL } from 'static/constant'
	import classlist from 'util/classlist'
	import { getDictionaryFromArray } from 'util/util'
	export default {
		name: "PageDeviceProtocolList",
		components: {
			Pagination,
			SubPage,
			PageDeviceProtocolEdit,
			TabModal
		},
		data() {
			return {
				loadingstatus: false,
				pageInfo: {
					pages: 1,
					total: 10,
					pageNum: 1
				},
				protocolId:[],
				deviceProtocol:[],
				devices:[],
				showSubPage: false,
				title: '',
                editItem: {}, //正在编辑的
				editMode: '',
				scrollTop: '0',
				listIndex: 0,
				brandCode:"",                    //品牌的code
				queryParam: {                   //查询参数
					protocolId:"",
					deviceProtocol:"",
					page_index: 1               //页码
				},
				deviceCategoryId:"",
				messageStr: "" ,                  // 弹出框提醒内容
				deviceInfo:{
					categoryId: ""
				}
			};
		},
		beforeMount() {
			this.getDevices();
		},
		methods: {
			//查询方法
			searchInfo() {
				this.queryParam.page_index = 1;
				this.getDevices();
			},
			//初始化信息
			getDevices() {    
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/system/device-protocol/', { params: this.queryParam })
					.then(res => {       
						if(res.body.success) {
							const resInfo = res.body.data;
							const { pageNum, pages, total, isFirstPage, isLastPage } = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,       
								isLastPage: isLastPage
							}
							this.devices = resInfo.list;
							this.loadingstatus = false;
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					},res => {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
					}).catch(res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
			},
		 
			//重置信息
			reset: function() {
				this.queryParam = {
					protocolId: "", //  
					deviceProtocol: "", //  
				}
			},
			getPageNo(pageNo) { //从分页组件获取页码参数
				//把分页参数传给后台，由后台返回新页码数据，再刷新页面
				this.queryParam.page_index = pageNo;
				this.getDevices();
			},
			remove(item) {
			this.editItem = item;
			this.openModal("modal2");
			},
			removeC() {		
				this.closeModal('modal2');
				let item = this.editItem;
				this.loadingstatus = true;
				this.$http.delete(process.env.API_ROOT + '/system/protocol/' + item.protocolId)
					.then(res => {
						if(res.data.success) {
							this.searchInfo();
						} else {
							this.openModalMsg(res.data.message);
							this.loadingstatus = false;
						}						
					},res => {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
					}).catch(res => {
						this.openModalMsg(res.data.message);
						this.loadingstatus = false;
					})			
			},
			//查询品牌名称
			findBrandCode(editItem) { 	
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/brandCode/'+this.editItem.categoryNo)
					.then(res => {
						if(res.body.success) { 
							this.brandCode = res.body.data;
						} else {
							this.openModalMsg(res.data.message);
							this.loadingstatus = false;
						}						
					},res => {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
					}).catch(res => {
						//this.openModalMsg(res.data.message);
						this.loadingstatus = false;
					})			
			},
			// 点击编辑
			edit(item,index) {
				classlist.toggleScroll('close', '#devicetypeList', this);
				this.editMode = 'edit';
				this.title = '编辑';
				this.editItem = item;
				this.deviceCategoryId = this.devices[index].categoryId;
			    this.findBrandCode(this.editItem);
				this.showSubPage = true;
			},
			createNew() {
				classlist.toggleScroll('close', '#devicetypeList', this);
				this.title = '新建';
				this.editMode = 'create';
				this.editItem = {};
				//this.deviceCategoryId = "";
				this.showSubPage = true;
			},
			check(item) {
				classlist.toggleScroll('close', '#devicetypeList', this);
				this.editMode = 'check';
				this.title = '查看';
				this.editItem = item;
				this.showSubPage = true;
			},
			endEdit(action) {
				this.$refs.edit.reset();
				this.deviceCategoryId ="";
				this.brandCode = "";
				this.editItem={};
				classlist.toggleScroll('open', '#devicetypeList', this);
				this.showSubPage = false;
				if(action == 'refresh')
					this.getDevices();
			},
			// 消息弹出框相关 ==============================
			openModal(ref) {
				this.$refs[ref].open();
				classlist.toggleScroll('close', '#devicetypeList', this);
			},
			closeModal(ref) {
				this.$refs[ref].close();
				classlist.toggleScroll('open', '#devicetypeList', this);
			},
			closeModalMsg() {
				this.closeModal("modal1");
			},
			openModalMsg(message) {
				this.messageStr = message;
				this.openModal("modal1")
			},
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// PageDeviceProtocolList.vue?40e13cfa